import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import SavedSearchMenuItems from '../containers/SavedSearchMenuItems';

const SearchLauncherDropdownMenu = ({ allowSaveSearches }) => (
  <Dropdown
    className="aridhia-search-launcher-menu"
    icon={null}
    trigger={(<RibbonMenu name="search" icon="search" message="fair.launcher.search" />)}
  >
    <Dropdown.Menu>
      <Dropdown.Item
        as="a"
        href={`#${relativeUrl(urls.SEARCH)}`}
        selected={false}
      >
        <Icon name="plus" className="primary" />
        <FormattedMessage id="search.header.menu.new" />
      </Dropdown.Item>
      {allowSaveSearches && (
        <>
          <Dropdown.Divider />
          <Dropdown.Item
            as="a"
            href={`#${relativeUrl(urls.SEARCHES)}`}
            selected={false}
          >
            <Icon name="list alternate" className="primary" />
            <FormattedMessage id="search.header.menu.saved" />
          </Dropdown.Item>
          <SavedSearchMenuItems category="ribbon" />
        </>
      )}
    </Dropdown.Menu>
  </Dropdown>
);

export default SearchLauncherDropdownMenu;
